import axios from 'axios';

import {
  getHeaders,
} from './Utils';

import {
  ENDPOINT_PROFILE
} from './constants';

export class Profile {
  static getAll() {
    return axios({
      method: 'get',
      headers: getHeaders(),
      url: `${ENDPOINT_PROFILE}`,
    }).catch((err) => {
      throw new Error(err);
    });
  }

  static getProfileById(id) {
    return axios({
      method: 'post',
      headers: getHeaders(),
      url: `${ENDPOINT_PROFILE}/getProfileByUserIdPublic`,
      data: {
        accountId: id
      },
    }).catch((err) => {
      throw new Error(err);
    });
  }

  static getProfileByURLShort(urlShort) {
    const filter = JSON.stringify({
      where: {
        urlShort: urlShort,
      },
      limit: 1,
    });
    return axios({
      method: 'get',
      headers: getHeaders(),
      url: `${ENDPOINT_PROFILE}/findOne?filter=${filter}`,
    }).catch((err) => {
      throw new Error(err);
    });
  }

}

export default Profile;



// WEBPACK FOOTER //
// ./src/api/Profile.js